module.exports = __webpack_public_path__ + "img/tn.1904bc09.jpg";